import { useQuery } from "@tanstack/react-query"

import StudentAssignmentsListController from "./StudentAssignmentsList.controller"
import { StudentAssignmentsTable } from "./StudentAssignmentsTable"
import { PageLayout } from "../components/PageLayout"
import { StudentAssignmentItem } from "../../app/controllers/student-assignments-list/student-assignment-folder-item"

interface StudentAssignmentsListProps {
  controller: StudentAssignmentsListController
}

export function StudentAssignmentsList({
  controller,
}: StudentAssignmentsListProps) {
  const {
    data: rows,
    isLoading,
    error,
  } = useQuery({
    queryKey: [controller.constructor.name, controller.fetchTableRows.name],
    queryFn: () => controller.fetchTableRows(),
  })

  const handleAssignmentClick = (item: StudentAssignmentItem) => {
    if (item.isWork) {
      controller.handleGoToWork(item.assignment)
    }
  }

  return (
    <PageLayout title="Assignments">
      {isLoading ? (
        <div className="tw-text-center tw-py-8">Loading Assignments...</div>
      ) : error ? (
        <div className="tw-text-center tw-text-destructive tw-py-8">
          Sorry, there was a problem loading your assignments
        </div>
      ) : !rows || rows.length === 0 ? (
        <div className="tw-text-center tw-py-8">
          When your teacher assigns you work, it will show up here!
        </div>
      ) : (
        <div className="tw-bg-white tw-shadow tw-overflow-hidden">
          <StudentAssignmentsTable
            data={rows}
            onAssignmentClick={handleAssignmentClick}
          />
        </div>
      )}
    </PageLayout>
  )
}
